import { useState } from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Badge } from "@/components/ui/badge";
import { ChevronDown } from "lucide-react";
import { WorkOrder } from "@/hooks/use-work-orders";

interface InlineStatusSelectProps {
  workOrder: WorkOrder;
  onUpdate: (id: string, status: string) => void;
  disabled?: boolean;
}

const statusOptions = [
  { value: "open", label: "Aberto", variant: "destructive" as const },
  { value: "in_progress", label: "Em Andamento", variant: "success" as const },
  { value: "closed", label: "Fechado", variant: "default" as const },
  { value: "cancelled", label: "Cancelado", variant: "outline" as const },
];

export function InlineStatusSelect({ workOrder, onUpdate, disabled = false }: InlineStatusSelectProps) {
  const [isOpen, setIsOpen] = useState(false);
  
  const currentStatus = statusOptions.find(opt => opt.value === workOrder.status);
  
  const handleValueChange = (newStatus: string) => {
    if (newStatus !== workOrder.status) {
      onUpdate(workOrder.id, newStatus);
    }
    setIsOpen(false);
  };

  if (disabled) {
    return <Badge variant={currentStatus?.variant} className="w-[130px] justify-center text-center">{currentStatus?.label}</Badge>;
  }

  return (
    <Select 
      value={workOrder.status} 
      onValueChange={handleValueChange}
      open={isOpen}
      onOpenChange={setIsOpen}
    >
      <SelectTrigger className="w-[130px] h-auto border-0 p-0 hover:bg-accent/50 rounded-md transition-colors [&>svg]:hidden">
        <SelectValue asChild>
          <Badge variant={currentStatus?.variant} className="cursor-pointer w-[130px] justify-center text-center flex items-center gap-1">
            {currentStatus?.label}
            <ChevronDown className="h-3 w-3" />
          </Badge>
        </SelectValue>
      </SelectTrigger>
      <SelectContent>
        {statusOptions.map((option) => (
          <SelectItem key={option.value} value={option.value}>
            <Badge variant={option.variant} className="w-[130px] justify-center text-center">{option.label}</Badge>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
